module.exports = "pegasus_template/assets/tech/large/1.jpg";